import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'

import { User } from './models/User'
import {
  Channel,
  ChannelMessage
} from './models/Channel'
import Workspace from './models/Workspace'
import Journal from './models/Journal'
import Subject from './models/Subject'
import {
  Material,
  MaterialCategory,
  MaterialGroup,
  MaterialType,
  MaterialAppearance,
  MaterialAppearancePart,
} from './models/Material'
import {
  FixedJournal,
  FixedJournalList
} from './models/FixedJournal'

import dashboard from './modules/dashboard'
import fixedJournals from './modules/fixedJournals'

import getters from './getters';
import actions from './actions'

Vue.use(Vuex)

const database = new VuexORM.Database()

database.register(User)
database.register(Channel)
database.register(ChannelMessage)
database.register(Workspace)
database.register(Journal)
database.register(Subject)
database.register(Material)
database.register(MaterialCategory)
database.register(MaterialType)
database.register(MaterialGroup)
database.register(MaterialAppearance)
database.register(MaterialAppearancePart)
database.register(FixedJournal)
database.register(FixedJournalList)

export default new Vuex.Store({
  state: {
    websocket: null,
    credentials: null
  },
  getters,
  actions,
  modules: {
    dashboard,
    fixedJournals
  },
  plugins: [VuexORM.install(database)]
})
